﻿import React, { useState, useEffect } from 'react';
import { HelperFunctions } from 'helpers';
import { Modal } from 'components/notifications/Modal';
import { ModalSize } from 'components/notifications/ModalSize';
import './Notifications.css';

export function AccountSwitcher(props) {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    function handleClose() {
        setIsOpen(false);   
        HelperFunctions.executeIfNotNull(props.onClose);
    }

    return (
        <Modal
            isOpen={isOpen}
            title="Switch Account"
            isCloseButtonShown={true}
            onClose={handleClose}
            size={ModalSize.SMALL}
        >
            {props.children}
        </Modal>
    );
}